module.exports = __webpack_public_path__ + "img/image-plus.97898bf5.svg";